import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { ClipboardList, CheckCircle, X } from "lucide-react";

export function SectionBTSuivi({ filteredDossiersProd, navigate }) {
  const incomplete = filteredDossiersProd.filter(d => {
    const s = d.sections_status || {};
    const isExterieur = d.departement === 'PRQC' && d.type_travaux !== 'interieur';
    const allOk = s.produits && s.codes_couleur && s.dates_chantier && s.equipe && (!isExterieur || s.lavage) && s.email_presentation && s.commande_initiale && (!isExterieur || (s.zones && s.etapes));
    return !allOk;
  });

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <ClipboardList className="w-4 h-4 text-indigo-600" />
          Bons de travail — Suivi des sections
        </CardTitle>
        <CardDescription>
          État de complétion par projet — {incomplete.length} projet(s) avec sections incomplètes sur {filteredDossiersProd.length}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="w-full text-xs" data-testid="bons-travail-table">
            <thead>
              <tr className="border-b bg-slate-50">
                <th className="text-left py-2 px-2 font-semibold text-slate-700 min-w-[140px]">Projet</th>
                <th className="text-center py-2 px-1 font-semibold text-slate-700 w-16">Produits</th>
                <th className="text-center py-2 px-1 font-semibold text-slate-700 w-16">Codes</th>
                <th className="text-center py-2 px-1 font-semibold text-slate-700 w-16">Dates</th>
                <th className="text-center py-2 px-1 font-semibold text-slate-700 w-16">Équipe</th>
                <th className="text-center py-2 px-1 font-semibold text-slate-700 w-16">Lavage</th>
                <th className="text-center py-2 px-1 font-semibold text-slate-700 w-16">Zones</th>
                <th className="text-center py-2 px-1 font-semibold text-slate-700 w-16">Etapes</th>
                <th className="text-center py-2 px-1 font-semibold text-slate-700 w-16" title="Courriel de présentation envoyé">Courr. prés.</th>
                <th className="text-center py-2 px-1 font-semibold text-slate-700 w-16">Commande</th>
                {/* 🆕 [Phase 30 #3b BIS] Colonne Heures bud. (3 états visuels — À l'heure / non approuvé / approuvé) */}
                <th className="text-center py-2 px-1 font-semibold text-slate-700 w-16" data-testid="th-heures-budgetees" title="Heures budgétées approuvées">Heures bud.</th>
              </tr>
            </thead>
            <tbody>
              {incomplete
                .sort((a, b) => {
                  const aInc = Object.values(a.sections_status || {}).filter(v => !v).length;
                  const bInc = Object.values(b.sections_status || {}).filter(v => !v).length;
                  return bInc - aInc;
                }).map(d => {
                  const s = d.sections_status || {};
                  const isExterieur = d.departement === 'PRQC' && d.type_travaux !== 'interieur';
                  const allOk = s.produits && s.codes_couleur && s.dates_chantier && s.equipe && (!isExterieur || s.lavage) && s.email_presentation && (!isExterieur || (s.zones && s.etapes));
                  return (
                    <tr key={d.id} onClick={() => navigate(`/crm/projets/${d.dossier_id || d.id}`)}
                      className={`border-b cursor-pointer transition-colors ${allOk ? 'hover:bg-emerald-50' : 'bg-amber-50/30 hover:bg-amber-50'}`}
                      data-testid={`bt-row-${d.id}`}>
                      <td className="py-2 px-2">
                        <p className="font-medium text-blue-700 truncate max-w-[180px]">{d.client_nom || d.nom_dossier}</p>
                        <p className="text-[10px] text-slate-400 truncate">{d.departement} {d.type_travaux ? `· ${d.type_travaux}` : ''}</p>
                      </td>
                      {[
                        { key: 'produits', always: true },
                        { key: 'codes_couleur', always: true },
                        { key: 'dates_chantier', always: true },
                        { key: 'equipe', always: true },
                        { key: 'lavage', always: isExterieur },
                        { key: 'zones', always: isExterieur },
                        { key: 'etapes', always: isExterieur },
                        { key: 'email_presentation', always: true },
                      ].map(sec => (
                        <td key={sec.key} className="text-center py-2 px-1">
                          {sec.always ? (
                            s[sec.key] ? (
                              <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-emerald-100">
                                <CheckCircle className="w-3.5 h-3.5 text-emerald-600" />
                              </span>
                            ) : (
                              <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-red-100">
                                <X className="w-3 h-3 text-red-500" />
                              </span>
                            )
                          ) : (
                            <span className="text-slate-300">—</span>
                          )}
                        </td>
                      ))}
                      <td className="text-center py-2 px-1">
                        {d.sections_status?.commande_initiale ? (
                          <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-emerald-100">
                            <CheckCircle className="w-3.5 h-3.5 text-emerald-600" />
                          </span>
                        ) : (
                          <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-red-100">
                            <X className="w-3 h-3 text-red-500" />
                          </span>
                        )}
                      </td>
                      {/* 🆕 [Phase 30 #3b BIS] Cellule Heures bud. — 3 états : À l'heure / approuvé / non approuvé */}
                      <td className="text-center py-2 px-1" data-testid={`td-heures-budgetees-${d.id}`}>
                        {d.a_l_heure ? (
                          <span className="text-slate-300" data-testid={`heures-bud-na-${d.id}`} title="BT marqué « À l'heure » — non applicable">—</span>
                        ) : (d.heures_budgetees_officielles !== null && d.heures_budgetees_officielles !== undefined && d.heures_budgetees_officielles !== 0) ? (
                          <span
                            className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-emerald-100"
                            data-testid={`heures-bud-ok-${d.id}`}
                            title="Heures budgétées approuvées"
                          >
                            <CheckCircle className="w-3.5 h-3.5 text-emerald-600" />
                          </span>
                        ) : (
                          <span
                            className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-red-100"
                            data-testid={`heures-bud-ko-${d.id}`}
                            title="Heures budgétées non approuvées"
                          >
                            <X className="w-3 h-3 text-red-500" />
                          </span>
                        )}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        {filteredDossiersProd.length === 0 ? (
          <p className="text-sm text-slate-400 italic text-center py-4">Aucun projet en production pour ce mois</p>
        ) : incomplete.length === 0 ? (
          <p className="text-sm text-emerald-600 italic text-center py-4" data-testid="all-bt-complete">Tous les bons de travail sont complets pour ce mois</p>
        ) : null}
      </CardContent>
    </Card>
  );
}
